import LoadingIcon from "components/LoadingIcon";

const LoadingView = () => {
  return (
    <div className="flex items-center justify-center w-16 h-[91px]">
      <LoadingIcon type="primary" className="w-[100%] h-[100%]" />
    </div>
  );
};

export default LoadingView;
